export const PLACEMENT_REVENUE_REPORT_REQUEST =
  "PLACEMENT_REVENUE_REPORT_REQUEST";
export const PLACEMENT_REVENUE_REPORT_SUCCESS =
  "PLACEMENT_REVENUE_REPORT_SUCCESS";
export const PLACEMENT_REVENUE_REPORT_FAIL = "PLACEMENT_REVENUE_REPORT_FAIL";
